import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || '';
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY || '';

if (!supabaseUrl || !supabaseKey) {
  console.warn('Supabase URL or Key is missing. Authentication will not work until these are configured.');
}

export const supabase = createClient(supabaseUrl, supabaseKey);

export const logoutUser = async () => {
  try {
    // 1. Desconecta usando escopo local para não travar se o token estiver expirado ou sem rede
    await supabase.auth.signOut({ scope: 'local' });
  } catch (err) {
    console.warn('Erro signOut escopo local, tentando fallback:', err);
    try {
      await supabase.auth.signOut();
    } catch (e) {
      console.error('Erro signOut fallback:', e);
    }
  } finally {
    // 2. Limpa todos os tokens do Supabase e Google do localStorage
    try {
      const keysToRemove: string[] = [];
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (
          key &&
          (key.startsWith('sb-') ||
            key.includes('supabase.auth.token') ||
            key.includes('google_provider_token'))
        ) {
          keysToRemove.push(key);
        }
      }
      keysToRemove.forEach((k) => localStorage.removeItem(k));
    } catch (e) {
      console.error('Erro limpando storage:', e);
    }

    // 3. Redireciona para a raiz para recarregar o estado e exibir a tela de login imediatamente
    window.location.href = '/';
  }
};